<template>
  <div class="bg-gray-950">
    <div class="overflow-x-auto">
      <div class="align-middle inline-block min-w-full">
        <!-- Header (outside the content + right panel row to match real layout spacing) -->
        <div class="rounded-t bg-gray-950">
          <div class="flex items-center justify-end flex-wrap sm:flex-nowrap">
            <div class="flex-1 pb-6">
              <h3 class="text-text-primary text-[28px] font-medium flex-grow">{{ $t('home.community_hub.title') }}</h3>
              <i18n-t scope="global" keypath="home.community_hub.intro" tag="p" class="text-sm leading-5 text-gray-300">
                <template #link>
                  <a class="text-indigo-400 underline" target="_blank" href="https://wiki.refrag.gg/en/community-hub">{{ $t('home.community_hub.more_info') }}</a>
                </template>
              </i18n-t>
            </div>
          </div>
        </div>

        <!-- Main content row with left column + right filters panel -->
        <div class="w-full flex gap-6 relative items-start pt-4">
          <div class="flex flex-col gap-4 flex-1">
            <!-- Controls row (active mod title + search + map dropdown) -->
            <div class="flex items-center gap-3 flex-col lg:flex-row">
              <h1 class="text-xl font-semibold text-text-primary flex-1">{{ activeMod }}</h1>
              <div v-if="showFilters" class="h-8 px-3 w-full lg:w-auto bg-gray-800 rounded-lg border border-gray-700 xl:hidden" />
              <div class="flex gap-3 w-full lg:w-auto">
                <div class="flex justify-center lg:justify-end w-full lg:w-auto">
                  <div class="h-8 w-full lg:w-42 rounded-md bg-gray-800 animate-pulse" />
                </div>
                <div class="h-8 w-[192px] rounded-md bg-gray-800 animate-pulse" />
              </div>
            </div>

            <!-- Content rows skeleton -->
            <div class="flex flex-col gap-1 lg:gap-[2px] rounded-lg w-full overflow-hidden">
              <CommunityHubContentRowSkeleton v-for="i in rows" :key="i" />
            </div>
          </div>

          <!-- Filters skeleton (only for Creator Studio layout) -->
          <div v-if="showFilters" class="w-full sm:w-auto sm:min-w-[360px] sm:max-w-[360px] min-h-[500px] p-6 bg-gray-900 rounded-lg flex-col gap-6 right-0 top-0 z-50 shadow-lg overflow-y-auto hidden xl:flex">
            <div class="w-full flex items-center pb-6 border-b border-gray-800">
              <div class="h-6 w-32 bg-gray-800 rounded animate-pulse flex-1" />
              <div class="h-4 w-14 bg-gray-800 rounded animate-pulse ml-2" />
            </div>
            <div class="flex flex-col gap-9 py-6">
              <div v-for="i in 3" :key="i" class="flex flex-col gap-3">
                <div class="h-3 w-24 bg-gray-800 rounded animate-pulse" />
                <div class="flex flex-col gap-4">
                  <div v-for="j in 3" :key="j" class="flex gap-2 items-center">
                    <div class="w-4 h-4 bg-gray-800 rounded animate-pulse" />
                    <div class="h-4 w-32 bg-gray-800 rounded animate-pulse" />
                    <div class="h-4 w-4 bg-gray-800 rounded animate-pulse ml-auto" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CommunityHubContentRowSkeleton from './CommunityHubContentRowSkeleton.vue';

const props = defineProps({
  rows: { type: Number, default: 6 },
  showFilters: { type: Boolean, default: true },
  activeMod: { type: String, default: 'Creator Studio' },
});
</script>
